import template from "./dialog-config.html";
import css from "./dialog-config.css";
import Dialog from "dialog";
import sleep from "sleep";
import DialogDevice from "../dialog-device.js";


class ConfigDialog extends DialogDevice {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-hamilton-dencytee", ConfigDialog);
  }
  constructor(...args) {
    super(...args);
  }
}

ConfigDialog.constructor();

export default ConfigDialog;